import useSWRMutation from 'swr/mutation';
import fetcher from 'lib/fetcher';
import { toast } from 'react-toastify';

const useAddFacilityToFavoriteList = (id: number | undefined, payload: number[]) => {
  async function fetchAddFacilityToFavoriteList(url: string) {
    try {
      const data = await fetcher.post(url, { facilityIds: payload });

      if (data?.error) {
        return toast.error(`Не удалось добавить объект: ${data?.error}`, { autoClose: 5000 });
      }

      toast.success('Объект успешно добавлен', { autoClose: 5000 });
      return data.result;
    } catch (error) {
      throw toast.error('Не удалось добавить объект', { autoClose: 5000 });
    }
  }

  const { data, error, isMutating, ...rest } = useSWRMutation(
    `/favourites/list/${id}/add`,
    fetchAddFacilityToFavoriteList,
  );

  return { data, error, isMutating, ...rest };
};
export default useAddFacilityToFavoriteList;
